







import { defineComponent } from "@vue/composition-api"

// components
import BaseLoading from "../../../../components/common/loading.vue"

export default defineComponent({
  name: "Loading",
  components: {
    BaseLoading
  },
  props: {
    isLoading: {
      type: Boolean,
      required: true
    }
  }
})
